import { HiPlus } from 'react-icons/hi'
import { LinkButton } from '@eggplant/pattern-library'
import { LinkToAddWebhook } from '@eggplant/routing'
import { SpaceAccessControl } from '@eggplant/context'

const AddNewWebhookButton = () =>
  <SpaceAccessControl isHiddenIfDenied>
    <LinkButton
      title='Add new webhook profile'
      variant='primary'
    >
      <LinkToAddWebhook>
        <HiPlus
          aria-hidden
          size='19.2px'
        />
        New webhook profile
      </LinkToAddWebhook>
    </LinkButton>
  </SpaceAccessControl>

export default AddNewWebhookButton
